import { DateTime } from "luxon";
import { useMemo } from "react";
import { formatCompactRelativeTime, type HistoryEntry } from "./history-model";
import { HistoryEntryThumbnail } from "./history-entry-thumbnail";

interface HistoryEntryRowProps {
  entry: HistoryEntry;
  onClick: (entry: HistoryEntry) => void;
}

export function HistoryEntryRow({ entry, onClick }: HistoryEntryRowProps) {
  const relativeTime = useMemo(
    () => formatCompactRelativeTime(entry.dateISO, DateTime.now()),
    [entry.dateISO],
  );

  return (
    <button
      type="button"
      onClick={() => onClick(entry)}
      className="flex w-full items-center gap-3 rounded-[16px] p-2 text-left transition-colors hover:bg-surfaces-z0"
    >
      <HistoryEntryThumbnail entry={entry} />
      <div className="flex min-w-0 flex-1 flex-col">
        <span className="truncate font-body text-body-2 text-text-primary">
          {entry.title}
        </span>
        <span className="truncate font-body text-body-3 text-text-tertiary">
          {entry.subline}
        </span>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        {entry.isUnread && (
          <span className="h-2 w-2 rounded-full bg-brand-periwinkle" />
        )}
        <span className="font-body text-body-4 text-text-tertiary">
          {relativeTime}
        </span>
      </div>
    </button>
  );
}
